const state = {
    rulesGroups: [],
    rules: [],
    eventRulesHistory: [],
    editedRuleToSave: null,
    selectedRuleItem: null,
    isLoadingRules: false,
    isLoadingGroups: false,
    isLoadingHistory: false,
    newGroupRule: null,
};

const getters = {
    getRules: (state) => state.rules,
    getRulesGroups: (state) => state.rulesGroups,
    getNewGroupRule: (state) => state.newGroupRule,
    getEventRulesHistory: (state) => state.eventRulesHistory,
    getSelectedRuleItem: (state) =>  state.selectedRuleItem,
    getLoadingRules: (state) => state.isLoadingRules,
    getLoadingGroups: (state) => state.isLoadingGroups,
    getLoadingHistory: (state) => state.isLoadingHistory,
    getEditedRuleToSave: (state) => state.editedRuleToSave,
};

const actions = {
    createRule({rootState}, payload) {
        return axios.post(`/api/PriceRule/Create?supplierId=${rootState.user.account.supplierId}`, 
        payload).then(response => {
            return response.status === 200;
        }).catch(() => {
            return false;
        });
    },

    downloadRules({rootState, commit}) {
        state.isLoadingRules = true;
        return axios.get('/api/PriceRule/GetAllBySupplierId', {
            params: {
                supplierId: rootState.user.account.supplierId,
            }
        }).then(response => {
            if(response.status === 200){
               commit('SET_RULES', response.data);
            }
        }).catch((err) => {
            err.message = null;
            commit('RESET_RULES');
        });
    },

    duplicateRuleOrGroup({rootState}, payload) {
        const endPointMap = {
            rules: { endPoint: 'PriceRule', paramId: 'priceRuleId' },
            rulesGroups: { endPoint: 'PriceGroup', paramId: 'priceGroupId' }
        };

        const { endPoint, paramId } = endPointMap[payload.type];

        const params = {
            supplierId: rootState.user.account.supplierId,
            [paramId]: payload.item.id,
            newName: payload.item.name
        };
          
        const queryString = new URLSearchParams(params).toString();
        
        return axios.post(`/api/${endPoint}/Duplicate?${queryString}`).then(response => {
            return response.status === 200;
        }).catch(() => {
            return false;
        });
    },

    deleteRule({rootState}, payload) {
        return axios.post(`/api/PriceRule/Update?supplierId=${rootState.user.account.supplierId}`,
        payload).then(response => {
            return response.status === 200;
        }).catch(() => {
            return false;
        });
    },

    updateRule({rootState}, payload) {
        return axios.post(`/api/PriceRule/Update?supplierId=${rootState.user.account.supplierId}`,
        payload).then(response => {
            return response.status === 200;
        }).catch(() => {
            return false;
        });
    },

    downloadRulesGroup({rootState, commit}) {
        state.isLoadingGroups = true;
        return axios.get('/api/PriceGroup/GetAllBySupplierId', {
            params: {
                supplierId: rootState.user.account.supplierId,
            }
        }).then(response => {
            if(response.status === 200){
               commit('SET_RULES_GROUP', response.data);
            }
        }).catch((err) => {
            err.message = null;
            commit('RESET_RULES_GROUP');
        });
    },

    createRuleGroup({rootState}, payload) {
        return axios.post(`/api/PriceGroup/Create?supplierId=${rootState.user.account.supplierId}`, 
            payload).then(response => {
            return response.status === 200;
        }).catch(() => {
            return false;
        });
    },

    updateRuleGroup({rootState}, payload) {
        return axios.post(`/api/PriceGroup/Update?supplierId=${rootState.user.account.supplierId}`,
            payload).then(response => {
            return response.status === 200;
        }).catch(() => {
            return false;
        });
    },

    deleteRuleGroup({rootState}, payload) {
        return axios.post(`/api/PriceGroup/Update?supplierId=${rootState.user.account.supplierId}`,
        payload).then(response => {
            return response.status === 200;
        }).catch(() => {
            return false;
        });
    },

    downloadRuleHistoryByEvent({rootState, commit, dispatch}, payload) {
        state.isLoadingHistory = true;
        return axios.get('/api/event/GetRuleHistoryByEventId', {
            params: {
                supplierId: rootState.user.account.supplierId,
                eventId: payload
            }
        }).then(response => {
            if(response.status === 200){
                commit('SET_EVENT_RULE_HISTORY', response.data);
            }
        }).catch((err) => {
            err.message = null;
            dispatch('clearEventRuleHistory');
        });
    },

    updateEditedRuleOrGroupToSave({commit}, payload) {
        commit('UPDATE_EDITED_RULE_TO_SAVE', payload);
    },
    
    clearEditedRuleToSave({commit}) {
        commit('CLEAR_EDITED_RULE_TO_SAVE');
    },

    setSelectedRuleItem: ({commit}, data) => {
        commit('SET_SELECTED_RULE_ITEM', data);
    },

    clearSelectedItemRule: ({commit}) => {
        commit('CLEAR_SELECTED_ITEM_RULE');
    },

    setNewGroupRule: ({commit}, data) => {
        commit('SET_NEW_GROUP_RULE', data);
    },

    clearNewGroupRule: ({commit}) => {
        commit('CLEAR_NEW_GROUP_RULE');
    },
    
    clearEventRuleHistory: ({commit}) => {
        commit('RESET_EVENT_RULE_HISTORY');
    },
};

const mutations = {
    SET_RULES: (state, data) => {
        state.rules = data;
        state.isLoadingRules = false;
    },

    SET_RULES_GROUP: (state, data) => {
        state.rulesGroups = data;
        state.isLoadingGroups = false;
    },

    SET_EVENT_RULE_HISTORY: (state, data) => {
        state.eventRulesHistory = data;
        state.isLoadingHistory = false;
    },

    UPDATE_EDITED_RULE_TO_SAVE: (state, data) => {
        state.editedRuleToSave = data;
    },

    CLEAR_EDITED_RULE_TO_SAVE: (state) => {
        state.editedRuleToSave = null;
    },

    RESET_RULES: (state) => {
        state.rules = [];
        state.isLoadingRules = false;
    },

    RESET_RULES_GROUP: (state) => {
        state.rulesGroups = [];
        state.isLoadingGroups = false;
    },

    RESET_EVENT_RULE_HISTORY: (state) => {
        state.eventRulesHistory = [];
        state.isLoadingHistory = false;
    },

    SET_SELECTED_RULE_ITEM: (state, data) => {
        state.selectedRuleItem = (data.id !== undefined) ? { type: data.type, item: state[data.type === 'rules' ? 'rules' : 'rulesGroups'].find(i => i.id === data.id) } : null;
    },
    
    SET_NEW_GROUP_RULE: (state, data) => {
        state.newGroupRule = data;
    },

    CLEAR_NEW_GROUP_RULE: (state) => {
        state.newGroupRule = null;
    },
    
    CLEAR_SELECTED_ITEM_RULE: (state) => {
        state.selectedRuleItem = null;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/rules.js